import {
  AugmentationComponent,
  AugmentationToolbarOption
} from "@pathwright/ux/src/components/augmentation/AugmentationToolbar"
import { useMemo } from "react"
import { useCoverPageTranslate } from "../utils"
import {
  CoverPagePanelCategoryCreateRoute,
  CoverPagePanelCategoryRoute
} from "./CoverPagePanelCategory"
import {
  CoverPagePanelContributorCreateRoute,
  CoverPagePanelContributorRoute
} from "./CoverPagePanelContributor"
import { CoverPagePanelHeaderRoute } from "./CoverPagePanelHeader"
import {
  CoverPagePanelOfferCreateRoute,
  CoverPagePanelOfferRoute
} from "./CoverPagePanelOffer"
import { CoverPagePanelOfferCohortCreateRoute } from "./CoverPagePanelOfferCohort"
import { CoverPagePanelPreviewRoute } from "./CoverPagePanelPreview"

export function useCoverPagePanelChildren(): NonNullable<
  AugmentationToolbarOption["children"]
> {
  const { t } = useCoverPageTranslate()

  return useMemo(
    () => [
      {
        key: "header",
        label: t("panel_sections.header", { defaultValue: "Header" }),
        AugmentationComponent: CoverPagePanelHeaderRoute
      },
      {
        key: "preview",
        label: t("panel_sections.preview", { defaultValue: "Preview" }),
        AugmentationComponent: CoverPagePanelPreviewRoute
      },
      {
        key: "contributors/new",
        label: t("panel_contributors.new_contributor", {
          defaultValue: "New contributor"
        }),
        AugmentationComponent: CoverPagePanelContributorCreateRoute
      },
      {
        key: "contributors/:contributorId",
        label: t("panel_contributors.contributor", {
          defaultValue: "Contributor"
        }),
        AugmentationComponent: CoverPagePanelContributorRoute
      },
      {
        key: "categories/new",
        label: t("panel_categories.new_category", {
          defaultValue: "New category"
        }),
        AugmentationComponent: CoverPagePanelCategoryCreateRoute
      },
      {
        key: "categories/:categoryId",
        label: t("panel_categories.category", {
          defaultValue: "Category"
        }),
        AugmentationComponent: CoverPagePanelCategoryRoute
      },
      {
        key: "offers/new",
        label: t("panel_offer.new_offer", { defaultValue: "New offer" }),
        AugmentationComponent: CoverPagePanelOfferCreateRoute,
        children: [
          {
            key: "cohorts/new",
            label: t("panel_offer_cohort.new_cohort", {
              defaultValue: "New Cohort"
            }),
            AugmentationComponent: CoverPagePanelOfferCohortCreateRoute
          },
          // @ts-expect-error: HACK: for "passing" /client/main components to /client/features
          window.groupManageToolbar,
          // @ts-expect-error: HACK: for "passing" /client/main components to /client/features
          window.licenseOfferingManageToolbar
        ]
      },
      {
        key: ":offerId",
        label: t("panel_offer.offer", { defaultValue: "Offer" }),
        AugmentationComponent:
          CoverPagePanelOfferRoute as AugmentationComponent,
        children: [
          // @ts-expect-error: HACK: for "passing" /client/main components to /client/features
          window.groupManageToolbar,
          // @ts-expect-error: HACK: for "passing" /client/main components to /client/features
          window.licenseOfferingManageToolbar
        ]
      }
    ],
    [t]
  )
}
